module.exports = __webpack_public_path__ + "static/airtable-1098310a601539e1a9b399245670e074.png";